import { Box, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditNoteIcon from "@mui/icons-material/EditNote";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { approveRejectCG, getCustomerGroups, getProductGroups, setState } from "./cgpgSlice";
import moment from "moment";

//#region Create Columns for Customer Group Table
function getCustomerGroupsCol() {
   const width = 200;
   return [
      { field: "customerGroupName", headerName: "Group Name", width: width },
      { field: "countryCode", headerName: "Country Code", width: width },
      { field: "status", headerName: "Status", width: width },
      { field: "updatedDate", headerName: "Last Action Date", width: width, valueFormatter: (params) =>moment(params.value).format('DD/MM/YYYY') },
      { field: "updatedBy", headerName: "Last Action By", width: width },
      {
			field: "reject",
			headerName: "Reject",
			widht: width,
			renderCell: RejectButton,
		},
		{
			field: "approve",
			headerName: "Approve",
			widht: width,
			renderCell: ApproveButton,
		},
      {
         field: "edit",
         headerName: "Edit",
         widht: width,
         renderCell: EditButton,
      },
   ];
}
//#endregion

// #region Customer Group Table Code
export default function CustomerGroupsTable() {
	const dispatch = useDispatch();
	const states = useSelector((store) => store.cgpgApproval);

	const { customerGroupsTable, selectedRows } = states;
	const {  rows } = customerGroupsTable;
   const columns = getCustomerGroupsCol();

   const [paginationModel, setPaginationModel] = useState({
      pageSize: 20,
      page: 0
   });

	return (
		<Box sx={{ mt: 3 }}>
			<DataGrid
				rows={rows}
				columns={columns}
				onRowSelectionModelChange={(selRows) => {
               dispatch(setState("selectedRows", selRows));
				}}
            rowSelectionModel={selectedRows}
            checkboxSelection
            disableRowSelectionOnClick
            disableColumnMenu
            paginationMode={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[ 20, 50, 100]}
			/>
		</Box>
	);
}
//#endregion 

// #region Reject Button Code
function RejectButton(params) {
	const dispatch = useDispatch();
   const states = useSelector((store) => store.cgpgApproval);
   const {
      customerGroups,
      selectedCountryID,
      selectedGroupStatus,
      selectedPeriod,
      selectedView,
   } = states;

   function search() {
      dispatch(setState("productGroupsTable", null));
      dispatch(setState("customerGroupsTable", null));
      dispatch(setState("customerGroups", null));
      dispatch(setState("customerGroups", null));
      dispatch(setState("selectedRows", []));

      const obj = {
         logedUser: JSON.parse(localStorage.getItem("data")),
         countryId: selectedCountryID,
         groupStatus: selectedGroupStatus,
         period: selectedPeriod,
         searchText: "",
      };

      if (selectedView === "Product Group") {
         dispatch(getProductGroups(obj));
      } else {
         dispatch(getCustomerGroups(obj));
      }
   }

   function reject() {
      const id = params.row.id;
      const customerGroup = customerGroups.find((cg) => cg.customerGroupID === id);
      const obj = {
         ...customerGroup,
         isApprove: 0,
      };
      console.log("Approval_CGPG_RejectPG", obj);
      dispatch(approveRejectCG(obj));
      search();
   }

   if (params.row.status.includes("Submitted")) {
      return (
         <IconButton onClick={reject}>
            <CancelIcon sx={{ color: "red.main" }} />
         </IconButton>
      );
   }
   return null;
}
// #endregion 

// #region Approve Button Code
function ApproveButton(params) {
	const dispatch = useDispatch();
   const states = useSelector((store) => store.cgpgApproval);
   const {
      customerGroups,
      selectedCountryID,
      selectedGroupStatus,
      selectedPeriod,
      selectedView,
   } = states;

   function search() {
      dispatch(setState("productGroupsTable", null));
      dispatch(setState("customerGroupsTable", null));
      dispatch(setState("customerGroups", null));
      dispatch(setState("customerGroups", null));
      dispatch(setState("selectedRows", []));

      const obj = {
         logedUser: JSON.parse(localStorage.getItem("data")),
         countryId: selectedCountryID,
         groupStatus: selectedGroupStatus,
         period: selectedPeriod,
         searchText: "",
      };

      if (selectedView === "Product Group") {
         dispatch(getProductGroups(obj));
      } else {
         dispatch(getCustomerGroups(obj));
      }
   }

   function approve() {
      const id = params.row.id;
      const customerGroup = customerGroups.find((cg) => cg.customerGroupID === id);
      const obj = {
         ...customerGroup,
         isApprove: 1,
      };
      console.log("Approval_CGPG_RejectPG", obj);
      dispatch(approveRejectCG(obj));
      search();
   }

   if (params.row.status.includes("Submitted")) {
      return (
         <IconButton onClick={approve}>
            <CheckCircleIcon sx={{ color: "green.main" }} />
         </IconButton>
      );
   }
   return null;
}
// #endregion
function EditButton(params) {
   return (
      <IconButton>
         <EditNoteIcon sx={{ color: "blue.main" }} />
      </IconButton>
   );
}
// #region Edit Button 


// #endregion